import React from 'react';
import PropTypes from 'prop-types';

import pallet from 'constants/colors';

const styles = {
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  value: {
    color: pallet.titleColor,
    fontWeight: 500,
    fontSize: 18,
  },
  label: {
    color: pallet.subtitleColor,
  },
  hover: {

  },
};

const KValue = ({
  value,
  label,
  containerStyle,
  valueStyle,
  labelStyle,
}) => (
  <div style={{ ...styles.container, ...containerStyle }}>
    <div style={{ ...styles.value, ...valueStyle }}>{value}</div>
    <div style={{ ...styles.label, ...labelStyle }}>{label}</div>
  </div>
);

KValue.propTypes = {
  value: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  valueStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  containerStyle: PropTypes.object,
};

export default KValue;



// WEBPACK FOOTER //
// ./src/components/KJRN/KValue.js